import React, { useState } from 'react';

const CancellationReasonModal = ({ isOpen, onClose, onSave, reasons }) => {
    const [reason, setReason] = useState('');
    const [otherDetails, setOtherDetails] =useState('');

    if (!isOpen) return null;

    const handleSave = () => {
        if (!reason) return;
        onSave({ reason, details: otherDetails });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[70]">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
                <h2 className="text-lg font-semibold mb-4">Provide Cancellation Reason</h2>
                <div className="space-y-4">
                    <div>
                        <label htmlFor="cancellation-reason" className="block text-sm font-medium text-gray-700">Reason</label>
                        <select
                            id="cancellation-reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            className="mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                        >
                            <option value="">-- Select a reason --</option>
                            {reasons.map(r => <option key={r} value={r}>{r}</option>)}
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    {reason === 'Other' && (
                        <div>
                            <label htmlFor="other-details" className="block text-sm font-medium text-gray-700">Details</label>
                            <textarea
                                id="other-details"
                                value={otherDetails}
                                onChange={(e) => setOtherDetails(e.target.value)}
                                rows="3"
                                className="mt-1 w-full p-2 border rounded-md"
                                placeholder="Please provide additional details..."
                            />
                        </div>
                    )}
                </div>
                <div className="flex justify-end space-x-3 mt-6">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
                        Cancel
                    </button>
                    <button 
                        type="button" 
                        onClick={handleSave} 
                        disabled={!reason}
                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:bg-gray-400"
                    >
                        Confirm Cancellation
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancellationReasonModal;